import { Box, Button, Divider, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';


interface IVMEmergencyPlanProps{
    id: string
}

export const VMEmergencyPlan: React.FC<IVMEmergencyPlanProps> = ({id}) =>{
    const navigate = useNavigate();
    const isButtonActive = (path: string) => {
        return location.pathname === path;
    };

    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));

    return (
    <Box
        display={'flex'}
        flexDirection={smDown? 'column' : 'row'}
        width={'100%'}
    >
        <Box
           display={'flex'}
           flexDirection={'column'}
           alignItems={smDown? 'center' :  'start'}
           width={smDown? '100%' : '50%'}
           padding={1}
        >
            <Typography variant='h6' color={theme.palette.primary.main} marginLeft={1}>Registos Legais</Typography>

            {/* <Button variant={isButtonActive(`/information_dam/${id}/aco`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/aco`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>ACO</Typography>
            </Button> */}

            <Button variant={isButtonActive(`/information_dam/${id}/emergency_plan`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/emergency_plan`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Plano de ação de emerência</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/aco`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/aco`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Avaliação de Conformidade e Operacionalidade</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/semiannual_internal_training`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/semiannual_internal_training`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Treinamento Interno Semestral</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/annual_guidance_seminar`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/annual_guidance_seminar`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Seminário Orientativo Anual</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/emergency_situation_simulation`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/emergency_situation_simulation`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Simulado de Situação de Emergência</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/emergency_situation_register`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/emergency_situation_register`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Registro de Situação de Emergências</Typography>
            </Button>
        </Box>
        <Divider orientation={smDown? 'horizontal' : 'vertical'} flexItem variant="fullWidth" />
        <Box
            display={'flex'}
            flexDirection={'column'}
            alignItems={smDown? 'center' :  'start'}
            width={smDown? '100%' : '50%'}
            padding={1}
        >
        </Box>
      </Box>
    );
};